import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import InitMaterialUI from './bootstrapping/InitMaterialUI';
import InitAuth0RequiringLogin from './bootstrapping/InitAuth0RequiringLogin';
import InitRequireProfile from './bootstrapping/InitRequireProfile';
import InitApiClient from './bootstrapping/InitApiClient';
import InitReactQuery from './bootstrapping/InitReactQuery';
import { HelmetProvider } from 'react-helmet-async';
import ConsoleProvider from './components/TestingInfo';
import { AppBarBoxContentProvider } from './components/AppBarBox';
import InitBackendAPI from './bootstrapping/InitBackendAPI';
import InitPostHog from './bootstrapping/InitPostHog';
import { isBrowserLocal, REACT_APP_DBS_API_URL, REACT_APP_SENTRY_DSN } from './bootstrapping/env';
import { RELEASE, sentryOptions } from './bootstrapping/sentry';
import { guardAgainstPageTranslation } from './bootstrapping/translationGuard';

console.log("[Sentry] Enabled:", REACT_APP_SENTRY_DSN !== undefined);
console.log('[Sentry] Release:', RELEASE);
// DBS-350: release, trace headers to the api, and the DBS-349 noise and replay settings
// DBS-359: browser page translation must not crash the page
guardAgainstPageTranslation(Node.prototype as never);

Sentry.init(sentryOptions({ dsn: REACT_APP_SENTRY_DSN, apiUrl: REACT_APP_DBS_API_URL, isLocal: isBrowserLocal }));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <InitMaterialUI>
        <InitPostHog>
          <InitAuth0RequiringLogin>
            <InitApiClient>
              <InitReactQuery>
                <InitBackendAPI>
                  <ConsoleProvider>
                    <InitRequireProfile>
                      <AppBarBoxContentProvider>
                        <App />
                      </AppBarBoxContentProvider>
                    </InitRequireProfile>
                  </ConsoleProvider>
                </InitBackendAPI>
              </InitReactQuery>
            </InitApiClient>
          </InitAuth0RequiringLogin>
        </InitPostHog>
      </InitMaterialUI>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
